import styled from "@emotion/styled";

export const HeaderWrapper = styled.div(({ theme }) => ({
	"&:nth-of-type(1)": {
		color: theme.project.colors.fontColors.main,
		display: "flex",
		gap: 16,
		gridColumn: "span 3",
		"div:nth-of-type(1)": {
			lineHeight: "20px",
			color: theme.project.colors.fontColors.main
		},
		"div:nth-of-type(2) > div:nth-of-type(2)": {
			color: theme.project.colors.fontColors.secondary
		}
	},
	[theme.breakpoints.down("md")]: {
		"&:nth-of-type(1)": {
			gridColumn: "1 / -1"
		},
		"div:nth-of-type(1)": {
			width: "100%"
		}
	}
}));

export const LineItemHeaderValue = styled.div({
	display: "flex",
	flexDirection: "column",
	fontSize: "var(--font-size-6)",
	gap: 8,
	"div:first-of-type": {
		fontWeight: 500
	}
});

export const LineItemNumberSkuDescriptionWrapper = styled.div(({ theme }) => ({
	display: "flex",
	gap: 16,
	"& > div:nth-of-type(1)": {
		color: `${theme.project.colors.fontColors.tertiary} !important`
	},
	[theme.breakpoints.down("md")]: {
		display: "grid",
		gridTemplateColumns: "max-content 1fr",
		gap: 16
	}
}));

export const LineItemContentDescription = styled.div(({ theme }) => ({
	fontSize: "var(--font-size-5)",
	[theme.breakpoints.down("md")]: {
		marginBottom: 6
	}
}));

export const AttributeContainerMobile = styled.div(({ theme }) => ({
	[theme.breakpoints.up("md")]: {
		display: "none"
	},
	[theme.breakpoints.down("md")]: {
		display: "flex",
		flexWrap: "wrap",
		gap: 8,
		"& > div": {
			display: "flex",
			gap: 8,
			width: "100%"
		},
		"span:nth-of-type(odd)": {
			...theme.project.typography.subtitle.subtitle2,
			color: theme.project.colors.fontColors.main
		},
		"span:nth-of-type(even)": {
			...theme.project.typography.body.body2,
			color: theme.project.colors.fontColors.secondary
		}
	}
}));

export const AttributeContainerDesktop = styled.div(({ theme }) => ({
	[theme.breakpoints.down("md")]: {
		display: "none !important"
	}
}));
